import type React from 'react';
import Breadcrumbs from 'components/Breadcrumbs';
import type { BreadcrumbsProps } from 'interfaces/navigation/Breadcrumbs';
import { ParseHtmlDefault } from 'utils/miscUtils/rawHtml';
import { COMMON_TEST_IDS } from 'constants/testsIds/common';
import SECTION_PAGE_TEST_IDS from 'constants/testsIds/sectionPage';
import * as S from './PageHeaderStyles';

export type PageHeaderProps = React.PropsWithChildren<{
  title: string;
  pageInfo?: string;
  isUsingPaths?: boolean;
  description?: string;
  breadcrumbs?: BreadcrumbsProps;
  className?: string;
}>;

const PageHeader = ({
  title,
  pageInfo,
  description,
  breadcrumbs,
  children: pinnedCardsList,
  className,
}: PageHeaderProps) => (
  <S.PageHeaderWrapper className={className}>
    {breadcrumbs?.items && breadcrumbs.items.length > 0 && (
      <Breadcrumbs
        {...breadcrumbs}
        hasBrandColor
      />
    )}
    <S.Title
      as='h1'
      $size={{ default: 'level2', lgMin: 'level1', xlMin: 'large' }}
      $fontFamily='saol'
      data-cy={SECTION_PAGE_TEST_IDS.HEADER_TITLE}
    >
      {title}
    </S.Title>
    {pageInfo && (
      <S.PageInfo
        as='h4'
        $size={{ default: 'level7', mdMin: 'level6' }}
        $fontFamily='graphikCond'
        data-cy={COMMON_TEST_IDS.PAGINATION_INFO}
      >
        {pageInfo}
      </S.PageInfo>
    )}
    {description && (
      <S.Description data-cy={SECTION_PAGE_TEST_IDS.HEADER_DESCRIPTION}>{ParseHtmlDefault(description)}</S.Description>
    )}
    {pinnedCardsList}
  </S.PageHeaderWrapper>
);

export default PageHeader;
